export default [
	{
		path: "/events",
		name: "events",
		meta: {
			requiresAuth: true,
			section: "events"
		},
		component: () => import("@/views/events/Events")
	},
	{
		path: "/events/create",
		name: "EventCreate",
		meta: {
			requiresAuth: true,
			section: "events"
		},
		component: () => import("@/views/events/EventForm")
	},
	{
		path: "/events/:id/update",
		name: "EventUpdate",
		meta: {
			requiresAuth: true,
			section: "events"
		},
		component: () => import("@/views/events/EventForm")
	},

	{
		path: "/events/:id/:tab?",
		name: "EventDetail",
		meta: {
			requiresAuth: true,
			section: "events"
		},
		component: () => import("@/views/events/EventDetail")
	}
]
